<template>
  <pt-news-classify-form ref="form" class="pt-news-classify-form__withData" :id="id" :isEdit="isEdit" :form="categry"></pt-news-classify-form>
</template>

<script>
import PtNewsClassifyForm from './form'
export default {
  name: 'pt-news-classify-form__withData',
  components: {
    'pt-news-classify-form': PtNewsClassifyForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      categry: {}
    }
  },
  methods: {
    enumerationDetial () {
      this.$store.dispatch('enumerationDetial', this.id).then(res => {
        this.categry = res
      }).catch(err => {
        this.$message.error(err || '获取新闻分类详情失败')
      })
    },
    submit () {
      this.form.validate().then(formValue => {
        let data = {
          categoriesId: formValue.id,
          categoriesName: formValue.name,
          categoriesValue: formValue.value,
          icon: formValue.extensionInfo.icon,
          newsSort: formValue.extensionInfo.sort
        }
        let apiUrl = this.isEdit ? 'editNewsCategories' : 'createEnumeration'
        this.$emit('submitLoad', true)
        this.$store.dispatch(apiUrl, data).then(data => {
          this.$emit('submitLoad', false)
          // doing something ...
          this.$message.success((this.isEdit ? '编辑' : '新建') + '新建分类成功')
          history.go(-1)
        }).catch(errorMessage => {
          this.$emit('submitLoad', false)
          this.$message.error(errorMessage || ((this.isEdit ? '编辑' : '新建') + '新建分类失败'))
        })
      })
    }
  },
  created () {
    if (this.isEdit) {
      this.enumerationDetial()
    }
  }
}
</script>
